import React from 'react';

import { toTitle } from '../../base2/utils';

import { AssetHeader } from './asset-header';
import { ValueDisplay } from './value-display';

interface Pet {
  name: string;
  type: string;
  breed: string;
  age: string;
  fund: string;
  careInstructions: string;
  careTaker?: {
    firstName: string;
    lastName: string;
  };
}

interface ArrangementsDisplayProps {
  pets: Pet[];
}

const getCareTakerName = (pet: Pet) => {
  const careTaker = pet.careTaker;
  if (!careTaker || !careTaker.firstName || !careTaker.lastName) {
    return 'No caretaker specified';
  }
  return toTitle([ careTaker.firstName, careTaker.lastName ].filter(Boolean).join(' '));
};

export function ArrangementsDisplay({ pets }: ArrangementsDisplayProps) {
  return (
    <div className="pet-arrangements-display screen-content">
      {pets.map((pet, index) => (
        <div key={index} className="pet-arrangement">
          <AssetHeader asset={{ name: pet.name, type: pet.type }} />
          <div className="value-display-container">
            <ValueDisplay label="Breed" value={pet.breed} />
            <ValueDisplay label="Age" value={pet.age} />
          </div>
          <div className="value-display-container">
            <ValueDisplay label="Caretaker" value={getCareTakerName(pet)} />
            <ValueDisplay label="Care Fund" value={pet.fund} />
            <ValueDisplay label="Care Instructions" value={pet.careInstructions} />
          </div>
        </div>
      ))}
    </div>
  );
}
